<template>
	<tr :class="rowClass">
		<td>
			{{msg(data.definition.resource)}}:
		</td>
		<td>
			<consolidable-item @selected="select" :text-data="data.textData1" position="left" :selected='selectedLeft'/>
		</td>
		<td>
			<consolidable-result v-model="model" :conflict="conflict" @selected="removeConflict('clickIn');" />
			<api-error v-for="err in errors" :level="err.level" :message="err.message"></api-error>
		</td>
		<td>
			<consolidable-item @selected="select" :text-data="data.textData2" position="right" :selected='selectedRight'/>
		</td>
	</tr>
</template>

<script setup lang="ts">
	import {ref, computed, provide} from "vue";
	import type {ConsolidableDataItem, MergeDefinition} from "@t/agenda/Consolidator";
	import ConsolidableItem from "./ConsolidableItem.vue";
	import ConsolidableResult from "./ConsolidableResult.vue";
	import ApiError from "@/fd/helpers/ApiError.vue";
	import {msg} from "@/i18n/Message";
	import usePart from "@/fd/Part";
	
	const props = defineProps<{
		data: ConsolidableDataItem,
		index: number
	}>();
	const model = defineModel();
	const {errors} = usePart({
		part: {
			type: "widget",
			catch: props.data.definition.property
		}
	});

	const rowClass = computed<string>(() => {
		return props.index % 2 === 0 ? "oddrow" : "evenrow";
	});
	
	const conflict = ref<boolean>(props.data.conflict);
	const selectedSource = ref<string>("");
	
	const selectedLeft = computed<boolean>(() => {
		return selectedSource.value==="left";
	});
	
	const selectedRight = computed<boolean>(() => {
		return selectedSource.value==="right";
	});
	
	const shiftSupport = computed<boolean>(() => {
		return props.data.definition.shiftSupport;
	});
	
	const emit = defineEmits(['removeConflict']);
	
	provide('definition', props.data.definition);
	
	function select(source: string, add: boolean): void {
		if (source==='left') {
			setData(props.data.data1, add);
		}
		else if (source==='right') {
			setData(props.data.data2, add);
		}
		//console.log("result:"+model.value[props.data.definition.property]);
		removeConflict(source);
	}
	
	function setData(data: any, add: boolean): void {
		if (model.value[props.data.definition.property] && add && shiftSupport.value) {
			if (Array.isArray(data)) {//array
				model.value[props.data.definition.property]=[...new Set([...model.value[props.data.definition.property], ...data])];
			}
			else {//string
				model.value[props.data.definition.property]=model.value[props.data.definition.property]+" "+data;
			}
		}
		else {
			if (Array.isArray(data)) {//array
				model.value[props.data.definition.property]=[...data];
			}
			else if (data instanceof Object) {//array
				model.value[props.data.definition.property]={...data};
			}
			else {
				model.value[props.data.definition.property]=data;
			}
		}
	}
	
	function removeConflict(source: string): void {
		//console.log("removing conflict");
		conflict.value=false;
		selectedSource.value=source;
		emit('removeConflict',props.data.definition.property);
	}
	
	//console.log("ROW:"+JSON.stringify(props.data));
</script>

